module.exports = __webpack_public_path__ + "static/media/logo.bc60c3d4.svg";